/** RefReps learnapp brand colors — aligned with Tailwind teal scale */
export const PORTAL_COLORS = {
  teal50: '#f0fdfa',
  teal100: '#ccfbf1',
  teal200: '#99f6e4',
  teal400: '#2dd4bf',
  teal500: '#14b8a6',
  teal600: '#0d9488',
  teal700: '#0f766e',
  /** Same gradient as .btn-primary (Tailwind from-teal-500 to-teal-600) */
  primarySurfaceGradient: 'linear-gradient(to bottom right, #14b8a6, #0d9488)',
  brandCyan: '#00CDC2',
  brandCyanLight: '#00ffcc',
  gray50: '#f9fafb',
  gray100: '#f3f4f6',
  gray200: '#e5e7eb',
  gray600: '#4b5563',
  gray700: '#374151',
  gray800: '#1f2937',
  navy: '#1a1a2e',
}

/** Inline / forced header bar — solid teal-600 matches .btn-primary perceived color on wide bars */
export const PORTAL_PRIMARY_HEADER_STYLE = {
  background: '#0d9488',
  backgroundColor: '#0d9488',
  color: '#ffffff',
  boxShadow: '0 2px 8px rgb(20 184 166 / 0.25)',
}

/** RGB tuple for teal-500 — use in rgba(..., alpha) */
export const PORTAL_ACCENT_RGB = '20, 184, 166'
